import { Tooltip, Typography } from 'antd'
import Style from './detail.module.scss'
interface Props {
  str?: string
  reason?: string[]
}

// 上次修改的数据
const Extra = (props: Props) => {
  const { str, reason } = props
  if (str || reason) {
    return (
      <>
        {str && (
          <Tooltip placement="top" title={str}>
            <Typography.Text type="danger" ellipsis>
              {str}
            </Typography.Text>
          </Tooltip>
        )}
        {str && <br />}
        <Tooltip
          placement="top"
          title={reason?.join('\n')}
          overlayClassName={Style['custom-tooltip']}
          getPopupContainer={() => document.body}
        >
          {reason?.map((i, index) => (
            <Typography.Text style={{ color: '#F57F17' }} ellipsis key={index}>
              {i}
            </Typography.Text>
          ))}
        </Tooltip>
      </>
    )
  }
  return null
}

export default Extra
import { Tooltip, Typography } from 'antd'
import Style from './detail.module.scss'
interface Props {
  str?: string
  reason?: string[]
}

// 上次修改的数据
const Extra = (props: Props) => {
  const { str, reason } = props
  if (str || reason) {
    return (
      <>
        {str && (
          <Tooltip placement="top" title={str}>
            <Typography.Text type="danger" ellipsis>
              {str}
            </Typography.Text>
          </Tooltip>
        )}
        {str && <br />}
        <Tooltip
          placement="top"
          title={reason?.join('\n')}
          overlayClassName={Style['custom-tooltip']}
          getPopupContainer={() => document.body}
        >
          {reason?.map((i, index) => (
            <Typography.Text style={{ color: '#F57F17' }} ellipsis key={index}>
              {i}
            </Typography.Text>
          ))}
        </Tooltip>
      </>
    )
  }
  return null
}

export default Extra
